var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm._m(3),
    _vm._v(" "),
    _vm._m(4),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "section-padding-home text-center" },
      [_c("section-partner"), _vm._v(" "), _vm._m(6)],
      1
    ),
    _vm._v(" "),
    _c("section", { staticClass: "section-padding-home mt-5" }, [
      _vm._m(7),
      _vm._v(" "),
      _vm._m(8),
      _vm._v(" "),
      _c("div", { staticClass: "mt-5 text-center" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("message.hero.or")))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-5" }, [
        _c("div", { staticClass: "col-lg-6 offset-lg-3" }, [
          _c("div", { staticClass: "card -bg-grey" }, [
            _c("div", { staticClass: "card-body" }, [
              _vm._m(9),
              _vm._v(" "),
              _c("div", { staticClass: "form" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "name" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("message.business.contact_name")) + "*"
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.contactData.name,
                        expression: "contactData.name"
                      }
                    ],
                    ref: "name",
                    staticClass: "form-control input-jumbo",
                    attrs: { type: "text", id: "name", required: "" },
                    domProps: { value: _vm.contactData.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.contactData, "name", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "company_name" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("message.business.contact_company_name")) +
                        "*"
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.contactData.company_name,
                        expression: "contactData.company_name"
                      }
                    ],
                    ref: "company_name",
                    staticClass: "form-control input-jumbo",
                    attrs: { type: "text", id: "company_name", required: "" },
                    domProps: { value: _vm.contactData.company_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.contactData,
                          "company_name",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "email" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("message.business.contact_province")) + "*"
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.contactData.province,
                        expression: "contactData.province"
                      }
                    ],
                    ref: "province",
                    staticClass: "form-control input-jumbo",
                    attrs: { type: "text", id: "province", required: "" },
                    domProps: { value: _vm.contactData.province },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.contactData,
                          "province",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "email" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("message.business.contact_email")) + "*"
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.contactData.email,
                        expression: "contactData.email"
                      }
                    ],
                    ref: "email",
                    staticClass: "form-control input-jumbo",
                    attrs: { type: "email", id: "email", required: "" },
                    domProps: { value: _vm.contactData.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.contactData, "email", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "tel" } }, [
                    _vm._v(_vm._s(_vm.$t("message.business.contact_tel")) + "*")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.contactData.tel,
                        expression: "contactData.tel"
                      }
                    ],
                    ref: "tel",
                    staticClass: "form-control input-jumbo",
                    attrs: { type: "tel", id: "tel", required: "" },
                    domProps: { value: _vm.contactData.tel },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.contactData, "tel", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button button-large button-block -cyan",
                  on: { click: _vm.sendEmail }
                },
                [_vm._v(" " + _vm._s(_vm.$t(_vm.isSending)) + "\n            ")]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-5" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h1", { staticClass: "sales-page-title text-center" }, [
          _vm._v("ออฟฟิศของคุณมีปัญหาแม่บ้านแบบนี้ไหม")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "section-padding-home" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("img", {
            staticClass: "img-fluid",
            attrs: {
              src: "/static/img/sales/cover.jpg",
              alt: "บีนีทแม่บ้านออนไลน์ ทำความสะอาด"
            }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "section-padding-home mt-5 text-center" },
      [
        _c("h2", { staticClass: "sales-page-title" }, [
          _vm._v("เรียกคุณแม่บ้าน BeNeat ไปแทน แบบไม่ต้องจ้างประจำ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-5" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "card -bg-grey" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "my-4" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/sales/ic-group.png",
                      alt: "บีนีทแม่บ้านออนไลน์ ทำความสะอาด",
                      height: "80"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "mt-3" }, [
                  _vm._v(
                    "\n              บีนีทมีแม่บ้านในระบบกว่า 1,000 คน\u0003ที่พร้อมให้บริการได้ทันที ไม่ต้องห่วงเรื่องวันลา"
                  ),
                  _c("br"),
                  _c("br")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "card -bg-grey" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "my-4" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/sales/ic-cerificate.png",
                      alt: "บีนีทแม่บ้านออนไลน์ ทำความสะอาด",
                      height: "80"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "mt-3" }, [
                  _vm._v(
                    "\n              คุณแม่บ้านทุกท่าน\u0003ผ่านการอบรมจากบีนีท ทั้งภาคทฤษฎีและปฏิบัติ ดังนั้นคุณภาพรับประกัน"
                  ),
                  _c("br"),
                  _c("br")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "card -bg-grey" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "my-4" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/sales/ic-time.png",
                      alt: "บีนีทแม่บ้านออนไลน์ ทำความสะอาด",
                      height: "80"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "mt-3" }, [
                  _vm._v(
                    "\n              สามารถจ้างรายชั่วโมงได้ เลือกจ้างเฉพาะวันที่จำเป็นต้องใช้จริงๆเท่านั้น ทำให้ประหยัดค่าจ้างแม่บ้านประจำไปได้\n            "
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "card -bg-grey" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "my-4" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/sales/ic-vat.png",
                      alt: "บีนีทแม่บ้านออนไลน์ ทำความสะอาด",
                      height: "80"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "mt-3" }, [
                  _vm._v(
                    "\n              สามารถออกใบเสร็จและใบกำกับภาษีได้ทุกงานหมดห่วงเรื่องเอกสารทางบัญชี"
                  ),
                  _c("br"),
                  _c("br")
                ])
              ])
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "section-padding-home mt-5 text-center" },
      [
        _c("h2", { staticClass: "sales-page-title" }, [
          _vm._v("วางใจในคุณภาพมาตรฐานสากล")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-5" }, [
          _c("div", { staticClass: "col-12 col-md-8 offset-md-6" }, [
            _c(
              "h2",
              {
                staticClass: "sales-page-title",
                staticStyle: { color: "#212121 !important" }
              },
              [
                _vm._v(
                  "\n          มีการฝึกอบรมมาตรฐานสากล และทั้งภาคทฤษฎีและภาคปฎิบัติ\u0003และมอบประกาศนียบัตรแก่ผู้ผ่านการอบรมหลักสูตรสากล\n        "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-5" }, [
          _c("div", { staticClass: "col-12 img-center" }, [
            _c("img", {
              staticClass: "img-fluid",
              attrs: {
                src: "/static/img/sales/standard01.jpg",
                alt: "บีนีทแม่บ้านออนไลน์ ทำความสะอาด"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-4" }, [
          _c("div", { staticClass: "col-md-5 col-12 mb-4" }, [
            _c("img", {
              staticClass: "img-fluid",
              attrs: {
                src: "/static/img/sales/standard02.jpg",
                alt: "บีนีทแม่บ้านออนไลน์ ทำความสะอาด"
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-7 col-12 mb-4" }, [
            _c("img", {
              staticClass: "img-fluid float-right",
              attrs: {
                src: "/static/img/sales/standard03.jpg",
                alt: "บีนีทแม่บ้านออนไลน์ ทำความสะอาด"
              }
            })
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "section-padding-home mt-5 text-center" },
      [
        _c("h2", { staticClass: "sales-page-title" }, [
          _vm._v("คุณค่าที่คุณจะได้รับ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-5" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "card -bg-grey" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("img", {
                  attrs: {
                    src: "/static/img/sales/ic-benefit01.png",
                    alt: "บีนีทแม่บ้านออนไลน์ ทำความสะอาด",
                    height: "42"
                  }
                }),
                _vm._v(" "),
                _c("h3", [_vm._v("ยืดหยุ่น")]),
                _vm._v(" "),
                _c("label", [
                  _vm._v(
                    "\n              ไม่จำเป็นต้องทำสัญญาจ้างระยะยาว\u0003"
                  ),
                  _c("br"),
                  _vm._v("เหมือนบริษัททำความสะอาดทั่วไป\n            ")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "card -bg-grey" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("img", {
                  attrs: {
                    src: "/static/img/sales/ic-benefit02.png",
                    alt: "บีนีทแม่บ้านออนไลน์ ทำความสะอาด",
                    height: "42"
                  }
                }),
                _vm._v(" "),
                _c("h3", [_vm._v("คล่องตัว")]),
                _vm._v(" "),
                _c("label", [
                  _vm._v("\n              ปรับเปลี่ยน, เพิ่ม-ลด การจอง\u0003"),
                  _c("br"),
                  _vm._v("ได้ตลอดเวลาตามที่สะดวก\n            ")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "card -bg-grey" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("img", {
                  attrs: {
                    src: "/static/img/sales/ic-benefit03.png",
                    alt: "บีนีทแม่บ้านออนไลน์ ทำความสะอาด",
                    height: "42"
                  }
                }),
                _vm._v(" "),
                _c("h3", [_vm._v("อุ่นใจ")]),
                _vm._v(" "),
                _c("label", [
                  _vm._v("\n              มีประกันความเสียหาย"),
                  _c("br"),
                  _vm._v("\u0003100,000 บาท ในทุกการจอง\n            ")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "card -bg-grey" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("img", {
                  attrs: {
                    src: "/static/img/sales/ic-benefit04.png",
                    alt: "บีนีทแม่บ้านออนไลน์ ทำความสะอาด",
                    height: "42"
                  }
                }),
                _vm._v(" "),
                _c("h3", [_vm._v("มีใบกำกับภาษี")]),
                _vm._v(" "),
                _c("label", [
                  _vm._v("\n              สามารถออกเอกสาร\u0003"),
                  _c("br"),
                  _vm._v("เพื่อลงเป็นต้นทุนของบริษัท\n            ")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "card -bg-grey" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("img", {
                  attrs: {
                    src: "/static/img/sales/ic-benefit05.png",
                    alt: "บีนีทแม่บ้านออนไลน์ ทำความสะอาด",
                    height: "42"
                  }
                }),
                _vm._v(" "),
                _c("h3", [_vm._v("เครื่องมือ-น้ำยา")]),
                _vm._v(" "),
                _c("label", [
                  _vm._v(
                    "\n              แม่บ้านไปให้บริการพร้อมเครื่องมือ-น้ำยา\u0003"
                  ),
                  _c("br"),
                  _vm._v("อุปกรณ์ทำความสะอาดครบครัน\n            ")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "card -bg-grey" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("img", {
                  attrs: {
                    src: "/static/img/sales/ic-benefit06.png",
                    alt: "บีนีทแม่บ้านออนไลน์ ทำความสะอาด",
                    height: "42"
                  }
                }),
                _vm._v(" "),
                _c("h3", [_vm._v("ประหยัดค่าใช้จ่าย")]),
                _vm._v(" "),
                _c("label", [
                  _vm._v("\n              จองบริการทำความสะอาด\u0003"),
                  _c("br"),
                  _vm._v("ตามขนาดธุรกิจของคุณ\n            ")
                ])
              ])
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "section-padding-home text-center" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("img", {
            staticClass: "img-fluid",
            staticStyle: { width: "100%" },
            attrs: {
              src: "/static/img/sales/pricing.jpg",
              alt: "บีนีทแม่บ้านออนไลน์ ทำความสะอาด"
            }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6" }, [
        _c(
          "div",
          { staticClass: "embed-responsive embed-responsive-16by9 mt-4" },
          [
            _c("iframe", {
              attrs: {
                width: "560",
                height: "315",
                src: "https://www.youtube.com/embed/RTbcjC9Udzg",
                frameborder: "0",
                allow: "autoplay; encrypted-media",
                allowfullscreen: ""
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _c(
          "div",
          { staticClass: "embed-responsive embed-responsive-16by9 mt-4" },
          [
            _c("iframe", {
              attrs: {
                width: "560",
                height: "315",
                src: "https://www.youtube.com/embed/xCGWH7JU83M",
                frameborder: "0",
                allow: "autoplay; encrypted-media",
                allowfullscreen: ""
              }
            })
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 text-center" }, [
        _c("h1", { staticStyle: { color: "#ff0019" } }, [
          _vm._v("แพ็คเกจโปรโมชั่น จำนวนจำกัด!")
        ]),
        _vm._v(" "),
        _c("h2", { staticStyle: { color: "#ff0019" } }, [
          _vm._v("เริ่มต้นเพียงเดือนละ "),
          _c("span", { staticStyle: { "background-color": "#ffde28" } }, [
            _vm._v(" 2,033 ")
          ]),
          _vm._v(" บาท")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-5" }, [
      _c("div", { staticClass: "col-md-12 text-center" }, [
        _c("h2", [_vm._v("สนใจติดต่อ")]),
        _vm._v(" "),
        _c("div", { staticClass: "business-contact" }, [
          _c("div", { staticClass: "mb-3" }, [
            _c("i", { staticClass: "fas fa-phone-square text-primary" }),
            _vm._v(" "),
            _c("a", { attrs: { href: "tel:021131138" } }, [
              _vm._v("02-113-1138")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-3" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://line.me/R/ti/p/@BeNeat",
                  target: "_blank"
                }
              },
              [
                _c("img", {
                  attrs: {
                    height: "38",
                    alt: "Line BeNeat",
                    src: "/static/img/btn-line.png"
                  }
                })
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my-4" }, [
      _c(
        "h3",
        { staticClass: "text-center", staticStyle: { color: "#ff0019" } },
        [_vm._v("ลงชื่อรับสิทธิโปรโมชั่นทันที")]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39840ac6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39840ac6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/sales/SalesBusiness.vue
// module id = 2127
// module chunks = 0